import { render } from "./PlansOverview.vue?vue&type=template&id=48f91718&scoped=true"
import script from "./PlansOverview.vue?vue&type=script&lang=js"
export * from "./PlansOverview.vue?vue&type=script&lang=js"

import "./PlansOverview.vue?vue&type=style&index=0&id=48f91718&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48f91718"]])

export default __exports__